import { Hub } from 'aws-amplify/utils';
import { createCredentialsCache } from './credentialsCache';

export type FolioSpeechToTextState = 'idle' | 'requesting' | 'recording' | 'error';

/**
 * Module-level credentials cache shared across all `useDictation` instances.
 * Cleared on sign-out / token-refresh failure so creds don't leak across
 * users on the same tab.
 */
export const folioSpeechToTextCredCache = createCredentialsCache();

if (typeof window !== 'undefined') {
  Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'signedOut' || payload.event === 'tokenRefresh_failure') {
      folioSpeechToTextCredCache.clear();
    }
  });
}
